import { QUERY_HEALTH_TOOL } from '@hhgtech/hhg-components/constants'
import queryString from 'query-string'

import {
  BmrInfo,
  BMRLocalStoredType,
  Category,
  HealthToolPositionType,
} from 'interfaces/types'
import { formatGenderUrl } from 'utils/format'

export const BMR_SIDIS_KEY = 'bmrInfo'

export const ACTIVITY_LEVEL_MAP_TO_SIDIS: { [v: string]: number } = {
  low_intensity: 1,
  moderate_intensity: 2,
  aerobic_intensity: 3,
  vigorous_intensity: 4,
  maximum_intensity: 5,
}

export function getBmrKcal(genderValue: string, info: BmrInfo) {
  return (
    Math.round(
      (genderValue === 'male'
        ? 66.47 +
          13.75 * parseFloat(info.weight) +
          5.003 * parseFloat(info.height) -
          6.755 * parseFloat(info.age)
        : 655.1 +
          9.563 * parseFloat(info.weight) +
          1.85 * parseFloat(info.height) -
          4.676 * parseFloat(info.age)) * 100,
    ) / 100
  )
}

export function generateBmrRedirect(
  baseUrl: string,
  // bmrKcal: number,
  genderValue: string,
  info: BmrInfo,
): string {
  const redirectUrl = queryString.stringifyUrl(
    {
      url: baseUrl,
      query: {
        result: 1,
        // [QUERY_HEALTH_TOOL.bmr]: bmrKcal,
        [QUERY_HEALTH_TOOL.gender]: formatGenderUrl(genderValue),
        [QUERY_HEALTH_TOOL.age]: info.age,
        [QUERY_HEALTH_TOOL.height]: info.height,
        [QUERY_HEALTH_TOOL.weight]: info.weight,
        [QUERY_HEALTH_TOOL.yourself]: Number(Boolean(info.isCheckYourself)),
        [QUERY_HEALTH_TOOL.activityLevel]: info.activityLevel,
        joincommunity: 1,
      },
    },
    {
      skipEmptyString: true,
      skipNull: true,
    },
  )
  return redirectUrl
}

export function generateBmrInfoToSendSidis(
  bmrKcal: number,
  genderValue: string,
  info: BmrInfo,
  {
    // isMobile,
    articleCategories,
    positionType,
  }: {
    isMobile: boolean
    articleCategories?: Category[] | null
    positionType: HealthToolPositionType
  },
) {
  const bmrInfo: BMRLocalStoredType = {
    age: info.age,
    height: info.height,
    weight: info.weight,
    kcal: bmrKcal,
    gender: genderValue,
    position_type: positionType,
    // device_type: isMobile ? 'mobile' : 'web',
    device_type: 'web',
    ...(info?.isCheckYourself && {
      is_my_self: 1,
    }),
    ...(info?.activityLevel && {
      active_level: ACTIVITY_LEVEL_MAP_TO_SIDIS?.[info.activityLevel] || 1,
    }),
    source_url: window.location.href,
  }

  if (articleCategories) {
    bmrInfo.categories = articleCategories.map((c) => ({
      name: c.name || '',
      permalink: c.permalink || '',
      term_id: c.termId || '',
      text_color: c.textColor || '',
    }))
  }

  return bmrInfo
}
